import { useState } from 'react';
import { useMinLoading } from '@/hooks/use-min-loading';
import type { AdminFeatureRequest } from '../../hooks/use-admin';
import { FRTable } from './feature-requests/FRTable';
import { FRToolbar } from './feature-requests/FRToolbar';

interface FeatureRequestsTabProps {
	featureRequests: AdminFeatureRequest[];
	loading: boolean;
	error: boolean;
	onRefresh: () => Promise<unknown>;
}

export function FeatureRequestsTab({
	featureRequests,
	loading,
	error,
	onRefresh,
}: FeatureRequestsTabProps) {
	const [refreshing, setRefreshing] = useState(false);
	const showRefreshing = useMinLoading(refreshing);

	const handleRefresh = async () => {
		setRefreshing(true);
		try {
			await onRefresh();
		} finally {
			setRefreshing(false);
		}
	};

	return (
		<div>
			<FRToolbar onRefresh={handleRefresh} refreshing={showRefreshing} />
			<FRTable
				rows={featureRequests}
				loading={loading}
				error={error}
				refreshing={showRefreshing}
			/>
		</div>
	);
}
